<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'

import CryptoJS from 'crypto-js';


export default {
  page: {
    title: 'View Training',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, Multiselect },
  data() {
    return {
      dismissSecs: 2,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      alertMessage:'',
      successStatus:true,
      processingData:false,
      dateOptions: { year: 'numeric', month: 'long', day: 'numeric' },

      pvtData: "",
      secret: "123#$%",
      encData: "",

      title: 'View Training Details',
      items: [
        {
          text: 'Hibret',
          href: '/',
        },
        {
          text: 'Training',
          href: '/Training',
        },
        {
          text: 'Training: '+this.$route.params.training.id,
          active: true,
        },
      ],
      title: this.$route.params.training.title,
      description: this.$route.params.training.description,
      date: this.$route.params.training.date,
      trainingMode: this.$route.params.training.trainingMode,
      venue: this.$route.params.training.venue,
      contentLink: this.$route.params.training.contentLink,
      submit: false,
      submitted: false,
      formsubmit: false,
      typesubmit: false,

      
      calendarConfig: {
          wrap: true, 
          dateFormat: 'd/m/Y',       
        },
    }
  },
  methods: {
      // encryption related methods
      encryptData(passwordData) {
        return CryptoJS.AES.encrypt(passwordData, this.secret).toString();
      },
      decryptData(encryptedData) {
        return CryptoJS.AES.decrypt(
          encryptedData,
          this.secret
        ).toString(CryptoJS.enc.Utf8);

      },

      gotoTrainings()
      {
        this.$router.push({ name: 'Training', params: { userId: '123' } });
      },

      gotoEditTraining()
      {
        this.$router.push({ name: 'Edit Training', params: { training: this.$route.params.training } });
      },

      checkStringLength(message)
      {
        if(message.length > 0)
        return true;
        else
        return false;
      }
      
  },
  mounted()
  {
    
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="$t('page.training.viewTrainingTitle')" />
    
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">{{ $t('page.training.trainingInformation') }}</h4>
            <p class="sub-header"
              ></p
            >

              <div class="form-group">
                <span class="sub-header">{{ $t('page.training.trainingId') }}</span>
                <h5 class="mt-0 mb-1" >{{ this.$route.params.training.id }}</h5>
              </div>
            
              <div class="form-group">
                <span class="sub-header">{{ $t('page.training.trainingTitle') }}</span>
                <h5 class="mt-0 mb-1" >{{ title }}</h5>
              </div>

              <div class="form-group">
                <span class="sub-header">{{ $t('page.training.trainingDescription') }}</span>
                <h5 class="mt-0 mb-1" >{{ description }}</h5>
              </div>

              <div class="form-group">
                <span class="sub-header">{{ $t('page.training.trainingDate') }}</span>
                <h5 class="mt-0 mb-1" >{{ date }}</h5>
              </div>

              <div class="form-group">
                <span class="sub-header">{{ $t('page.training.trainingMode') }}</span>
                <h5 class="mt-0 mb-1" >{{ trainingMode }}</h5>
              </div>

              <div v-if="trainingMode=='Offline'" class="form-group">
                <span class="sub-header">{{ $t('page.training.trainingVenue') }}</span>
                <h5 class="mt-0 mb-1" >{{ venue }}</h5>
              </div>

              <div v-else class="form-group">
                <span class="sub-header">{{ $t('page.training.trainingContentLink') }}</span>
                <a :href='contentLink' target="blank"><h5 class="mt-0 mb-1" >{{ contentLink }}</h5></a>
              </div>

              <!--div v-if="this.$route.params.training.fileNames.length>0" class="form-group">
                <span class="sub-header">Attached Files</span>
                <ul id="example-1">
                  <li v-for="item in this.$route.params.training.fileNames" :key="item" style="margin:10px 0">
                    <b-button  variant="outline-primary">{{ item }}</b-button>
                  </li>
                </ul>
              </div-->

          </div>
        </div>
        <!-- end card--->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    
    <div  v-if="this.$store.state.auth.currentUser" class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
                  
            <!--form @submit.prevent="handleSubmit">
                  <button v-if='!processingData' type="submit" class="btn btn-primary"
                    >Save</button>
                  <button v-else disabled  class="btn btn-primary"
                  >Save</button>
                  <a href="/member">
                  <button class="btn btn-secondary m-l-5 ml-1"
                    >Cancel</button></a>
            </form-->
            <form @submit.prevent="handleSubmit">
            <template>
              <b-button  v-if="this.$store.state.auth.currentUser.accessLevel!='User'" variant="primary" @click="gotoEditTraining"><i class="uil uil-pen mr-1"></i>{{ $t('page.training.editTrainingDetails') }}</b-button>
              <!--b-button variant="success" style="margin-left:10px;"><i class="uil uil-comment-alt-lines mr-1"></i>Send Message</b-button-->
							<b-button variant="light" @click="gotoTrainings" style="margin-left:10px;">{{ $t('page.training.close') }}</b-button>	
						</template>
            </form>
                  
          </div>
        </div>
        <!-- end card--->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    
  </Layout>
</template>
<style scoped>
.btn {
  font-size: 1rem;
}
.btnSmallAm {
  font-size: 0.875rem;
}
.btnSmallEn {
  font-size: 0.675rem;
}
.lighterTextAm {
  font-weight: 500 !important;
  font-size: 1rem !important;
}
.lighterTextEn {
  font-weight: 600 !important;
  font-size: 0.875rem !important;
}
.lighterTextSmallAm {
  font-weight: 500 !important;
  font-size: 0.875rem !important;
}
.lighterTextSmallEn {
  font-weight: 600 !important;
  font-size: 0.675rem !important;
}
</style>
